import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {
  DocumentTemplateTableComponent, DocumentTemplateTableComponentData
} from "@modules/document-template/components/document-template-table/document-template-table.component";

@Component({
  standalone: true,
  selector: 'app-document-template-table-dialog',
  templateUrl: './document-template-table-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButtonModule,
    DocumentTemplateTableComponent
  ],
  styleUrls: ['./document-template-table-dialog.component.scss']
})
export class DocumentTemplateTableDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: DocumentTemplateTableComponentData,
    protected readonly dialogRef: MatDialogRef<DocumentTemplateTableDialogComponent>,
  ) {
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close()
  }
}
